import { render, staticRenderFns } from "./ChainIndex.vue?vue&type=template&id=7bda69f9&scoped=true"
import script from "./ChainIndex.vue?vue&type=script&lang=js"
export * from "./ChainIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bda69f9",
  null
  
)

export default component.exports